import { useIntl } from 'react-intl';

import { useRectSeriesTooltipHeaderContent } from './hooks/useRectSeriesTooltipHeaderContent.js';
import { safeGet } from '../../../../core/utils/safe-get.js';
import { useAxesFormatter } from '../../../hooks/useAxesFormatter.js';
import { useRectData } from '../../../hooks/useRectData.js';
import type {
  RectDatapointInternal,
  RectSeriesWithDatapoints,
} from '../../../types/xy-chart-internals.js';
import { getTooltipFormatter } from '../utils/get-tooltip-formatter.js';
import { XYChartTooltipBody } from '../XYChartTooltipBody/XYChartTooltipBody.js';

export interface RectTooltipBodyProps {
  datapoint: RectDatapointInternal;
  series: RectSeriesWithDatapoints;
}

export function RectSeriesTooltipBody({
  datapoint,
  series,
}: RectTooltipBodyProps) {
  const intl = useIntl();
  const axisIdToFormatter = useAxesFormatter();
  const { seriesToMetadata } = useRectData();

  const { xAxis, yAxis } = safeGet(seriesToMetadata, series);

  const xFormatter = getTooltipFormatter(xAxis, axisIdToFormatter, intl);
  const yFormatter = getTooltipFormatter(yAxis, axisIdToFormatter, intl);

  const { x0, x1, y0, y1 } = datapoint;
  const { text: textX, duration: durationX } =
    useRectSeriesTooltipHeaderContent(x0, x1, xFormatter);
  const { text: textY, duration: durationY } =
    useRectSeriesTooltipHeaderContent(y0, y1, yFormatter);
  return (
    <XYChartTooltipBody
      xAxisLabel={xAxis.label}
      yAxisLabel={yAxis.label}
      xAxisValue={textX}
      yAxisValue={textY}
      xAxisDuration={durationX}
      yAxisDuration={durationY}
    />
  );
}

RectSeriesTooltipBody['displayName'] = 'RectSeriesTooltipBody';
